module.exports = __webpack_public_path__ + "static/4item-4bc776737e7c74e12f33b80ece44560f.png";